import { Link } from "react-router"
import type { Locale } from "../content/types"
import { getPagePath } from "../content/registry"
import { ui } from "../content/ui"

interface PageCtaProps {
  locale: Locale
  title?: string
  description?: string
}

/** Shared bottom-of-page call-to-action block linking to Contact. */
export default function PageCta({ locale, title, description }: PageCtaProps) {
  const heading =
    title ?? (locale === "nl" ? "Laten we je project bespreken" : "Let's discuss your project")
  const body =
    description ??
    (locale === "nl"
      ? "Of je nu iets nieuws wilt bouwen of bestaande processen wilt optimaliseren: neem contact op en laten we in gesprek gaan."
      : "Whether you want to build something new or optimise existing processes: get in touch and let's start a conversation.")

  return (
    <section className="max-w-4xl mx-auto mt-20">
      <div className="bg-card-bg rounded-3xl border border-border-subtle shadow-lg p-8 md:p-12 lg:p-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">{heading}</h2>
        <p className="text-lg text-text-secondary mb-8 max-w-2xl mx-auto">{body}</p>
        <Link
          to={getPagePath("contact", locale)!}
          className="inline-block bg-button-primary hover:bg-[#c55b01] text-white px-8 py-4 rounded-pill font-semibold transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
        >
          {ui.cta.contact[locale]}
        </Link>
      </div>
    </section>
  )
}
